var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("DT_NavBar", {
        attrs: {
          tool: _vm.tool,
          showMenu: false,
          menuCollapsed: _vm.menuCollapsed,
        },
        on: {
          loadProject: _vm.handleNavLoad,
          reset: _vm.handleReset,
          toggleCollapse: _vm.toggleCollapse,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "main-content hub-content" }, [
        _c("nav", { staticClass: "mmp-fixed-nav" }, [
          _c("div", { staticClass: "mmp-user-info" }, [
            _c(
              "span",
              { staticClass: "mmp-user-avatar" },
              [_c("fa", { attrs: { icon: ["fas", "user"] } })],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "mmp-user-greeting" }, [
              _c("span", { staticClass: "mmp-user-greeting-label" }, [
                _vm._v("Welcome back"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mmp-user-greeting-name" }, [
                _vm._v(_vm._s(_vm.user ? _vm.user : "")),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mmp-nav-actions" }, [
            _c(
              "button",
              {
                staticClass: "notif-bell-btn signout-btn",
                attrs: { title: "Sign Out" },
                on: { click: _vm.signOut },
              },
              [_c("fa", { attrs: { icon: ["fas", "sign-out-alt"] } })],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "hub-center" }, [
          _c("p", { staticClass: "hub-subtitle" }, [
            _vm._v("Select a tool to get started"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "hub-widgets" }, [
            _vm.globalIsUserAllowed("Data_Delivery_Tool")
              ? _c(
                  "div",
                  {
                    staticClass: "hub-card",
                    on: {
                      click: function ($event) {
                        return _vm.goTo("DDT")
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "hub-icon-wrap" },
                      [
                        _c("fa", {
                          staticClass: "hub-icon",
                          attrs: { icon: ["fas", "road"] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "hub-arrow" }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.globalIsUserAllowed("Trail_Review_Tool")
              ? _c(
                  "div",
                  {
                    staticClass: "hub-card",
                    on: {
                      click: function ($event) {
                        return _vm.goTo("TRT")
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "hub-icon-wrap" },
                      [
                        _c("fa", {
                          staticClass: "hub-icon",
                          attrs: { icon: ["fas", "route"] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "hub-arrow" }),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "copyright" }, [
          _c(
            "a",
            {
              staticClass: "attribution",
              attrs: { href: "https://dmp-maps.com/legal/", target: "_blank" },
            },
            [
              _vm._v(
                "\n                © " +
                  _vm._s(new Date().getFullYear()) +
                  " Dynamic Map Platform North America, Inc. All Rights Reserved\n            "
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hub-card-body" }, [
      _c("div", { staticClass: "hub-title" }, [_vm._v("Map Data")]),
      _vm._v(" "),
      _c("div", { staticClass: "hub-desc" }, [
        _vm._v(
          "Request, track, and manage data delivery orders across regions."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hub-card-body" }, [
      _c("div", { staticClass: "hub-title" }, [_vm._v("Lidar Data")]),
      _vm._v(" "),
      _c("div", { staticClass: "hub-desc" }, [
        _vm._v("Review, submit, and manage trail sample requests."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }